import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import USPStrip from "@/components/USPStrip";
import SahyogPromise from "@/components/SahyogPromise";
import EmiCalculator from "@/components/EmiCalculator";
import CustomersBanner from "@/components/CustomersBanner";
import Services from "@/components/Services";
import OurProcess from "@/components/OurProcess";
import HowItWorks from "@/components/HowItWorks";
import BrandVoice from "@/components/BrandVoice";
import CorporateServices from "@/components/CorporateServices";
import WhyChooseUs from "@/components/WhyChooseUs";
import AssociatesBanner from "@/components/AssociatesBanner";
import CareerLadder from "@/components/CareerLadder";
import DSASlabs from "@/components/DSASlabs";
import ComplianceStrip from "@/components/ComplianceStrip";
import OurValues from "@/components/OurValues";
import BrandMark from "@/components/BrandMark";
import Leadership from "@/components/Leadership";
import About from "@/components/About";
import Contact from "@/components/Contact";
import PartnerPillars from "@/components/PartnerPillars";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative">
      <Navbar />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <USPStrip />
        <SahyogPromise />
        <EmiCalculator />
        <CustomersBanner />
        <Services />
        <OurProcess />
        <HowItWorks />
        <BrandVoice />
        <CorporateServices />
        <WhyChooseUs />
        <div id="career">
          <AssociatesBanner />
          <CareerLadder />
          <DSASlabs />
        </div>
        <ComplianceStrip />
        <OurValues />
        <BrandMark />
        <Leadership />
        <About />
        <Contact />
        <PartnerPillars />
      </main>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
